(function ($) {
    $(document).ready(function () {
        // Подсветка пунктов меню
        var link = window.location.pathname;
        $('a[href="' + link + '"]').parents('.dropdown-item').addClass('active');
        $('a[href="' + link + '"]').parents('.nav-item').addClass('active');

        var $dropdown = $(".dropdown");
        var $dropdownToggle = $(".dropdown-toggle");
        var $dropdownMenu = $(".dropdown-menu");
        var $groupItems = $('li.group-item');
        var showClass = "show";
        var isDefaultTplChanged = 0; // флаг, что мы динамически изменили начальный шаблон top-menu.twig
        var pointerMode = ''; // флаг предыдущего режима для указателя на экране (в if-else здесь), чтобы не обрабатывать ресайзы без необходимости. Варианты: '' (при load), hover, click

        $(window).on("load resize", function(ev) {
            // десктоп с указателем, поддерживающим hover
            if (this.matchMedia("(min-width: 992px) and (hover: hover) and (pointer: fine)").matches) {
                if (pointerMode !== 'hover') {

                    $('.dropdown-menu [data-toggle=dropdown]').off('click'); // для ресайза с мобильной версии на десктопную

                    // изменяем шаблон top-menu.twig: обрабатываем пункты меню со страницами категорий (подставляем ссылку в основной пункт и убираем соотв. пункт из подменю)
                    $groupItems.each(function(index, element) {
                        var href = $(element).children('a').attr('href');
                        $(element).parent('ul').prev('a').attr('href', href).removeAttr('data-toggle').removeClass('dropdown-toggle');
                    });
                    $groupItems.hide(); // скрываем пункты категорий из подменю
                    isDefaultTplChanged = 1;
                    pointerMode = 'hover';

                    $dropdown.hover(
                        function() {
                            var $this = $(this);
                            $this.addClass(showClass);
                            $this.children($dropdownToggle).attr("aria-expanded", "true");
                            $this.children($dropdownMenu).addClass(showClass);
                        },
                        function() {
                            var $this = $(this);
                            $this.removeClass(showClass);
                            $this.children($dropdownToggle).attr("aria-expanded", "false");
                            $this.children($dropdownMenu).removeClass(showClass);
                        }
                    );
                }
            } else {
                // мобильная версия или нет поддержки hover
                if (pointerMode !== 'click') {

                    $dropdown.off("mouseenter mouseleave");

                    pointerMode = 'click';

                    // обрабатываем пункты меню со страницами категорий (возврат к дефолтному состоянию шаблона, если менялся)
                    if (isDefaultTplChanged) {
                        $groupItems.each(function(index, element) {
                            var $tagA = $(element).parent('ul').siblings('a');
                            var href = $tagA.attr('href');
                            $(element).children('a').attr('href', href);
                            $tagA.attr('href', '#');
                            $tagA.attr('data-toggle', 'dropdown');
                        });
                        $groupItems.show();
                        isDefaultTplChanged = 0;
                    }

                    // Логика вложенного многомерного меню (старая версия 'как была', но siblings вместо next)

                    // При клике на 1 уровне, скрывает выпадающие меню др. пунктов верхнего уровня
                    $('.nav-link[data-toggle=dropdown]').on('click', function (e) {
                        $(this).siblings().find('.show').removeClass(showClass);
                    });
                    // клик на ярлыках без ссылок (2 и 3 уровень)
                    $('.dropdown-menu [data-toggle=dropdown]').on('click', function (e) {
                        // ?? если Следующий ярлык не имеет класс шоу, то у этого в предках скрыть первый выпадающий список
                        if (!$(this).siblings().hasClass(showClass)) {
                            $(this).parents('.dropdown-menu').first().find('.show').removeClass(showClass);
                        }
                        var $subMenu = $(this).siblings(".dropdown-menu"); // др. одноуровневые меню (а не подменю этого) - ??
                        $subMenu.toggleClass(showClass);
                        $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function (e) {
                            $('.dropdown-submenu .show').removeClass(showClass);
                        });
                        return false;
                    });
                }
            }
        });

        // Блокировка прокручивание страницы при развернутом мобильном меню
        $('.toggle-switch').on('click', function () {
            if ($('.toggle-switch').attr('aria-expanded') === 'false') {
                $("body").css("overflow", "hidden");
            } else {
                $("body").css("overflow", "auto");
            }
        });

        // Иконка мобильного меню
        var toggles = document.querySelectorAll(".toggle-switch");
        for (var i = toggles.length - 1; i >= 0; i--) {
            var toggle = toggles[i];
            toggleHandler(toggle);
        }
        function toggleHandler(toggle) {
            toggle.addEventListener("click", function (e) {
                e.preventDefault();
                (this.classList.contains("active") === true) ? this.classList.remove("active") : this.classList.add("active");
            });
        }
    });
})(jQuery);
